import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidWordBuilding } from '../../../../components/mechanics/rid-word-building/rid-word-building';

@Component({
  selector: 'app-word-building-page',
  imports: [RidWordBuilding],
  templateUrl: './word-building-page.html',
})
export class WordBuildingPage {
  protected readonly $router = inject(Router);
}
